import styles from "./ShortFormListTable.module.scss"

import React from "react"

interface Props {
  height?: number
  children: React.ReactNode
}

export default function ShortFormListTable({ height, children }: Props) {
  return (
    <div className={styles.wrap} style={height ? { height } : undefined}>
      <ul className={styles.list}>{children}</ul>
    </div>
  )
}
